export const ROUTER_NAMES = {
  AUTH: '/auth',
  USERS: '/users',
  SUPERVISORS: '/supervisors',

  // Заявки
  APPLICATIONS: '/applications',
  MKASSA: '/applications/mkassa',
  MPOST: '/applications/mpost',
  MBUSINESS: '/applications/mbusiness',
  OPEN_MBUSINESS: '/applications/open-mbusiness',
  MQR: '/applications/mqr',
  NON_RESIDENT: '/applications/non-resident',
  MPLUS: '/applications/mplus',
  INSTANT_CARD: '/applications/instant-card',
  MBONUS: '/applications/mbonus',
  REVIVAL: '/applications/revival',
  MANUAL_REPORTS: '/applications/manual-reports',
  REVIVAL_REPORTS: '/applications/manual-reports/revival',
  ACQUIRED_CLIENTS_REPORTS: '/applications/manual-reports/acquired-clients',
  APPLICATION_AUTO_REPORTS: '/applications/auto-reports',
  ACQUIRED_CLIENTS: '/applications/acquired-clients',
  // ^^^ Заявки ^^^

  CONTACT_CENTER: '/kc',
  FILIAL: '/filial',
  ATTRACTORS: '/attractors',
  CALCULATORS: '/calculators',
  NOT_FOUND: '/404',

  // ЛОГИСТИКА
  LOGISTIC: '/logistic',
  NEW: '/new/dispatcher',
  NEW_TERRITORIES: '/new/inventory/subterritories',
  ISSUANCE: '/new/issuance',
  LOGISTIC_PROCESSED: '/logistic/processed',
  LOGISTIC_FILLIALS_APPS: '/logistic/fillials-apps',
  LOGISTIC_FILLIALS_ACTS: '/logistic/fillials-acts',
  LOGISTIC_REPORTS: '/logistic/reports',
  // ^^^ ЛОГИСТИКА ^^^
}

// dispatcher
